<script setup lang="ts">
import { computed } from 'vue'

import Icon from '../shared/Icon.vue'
import TeaserGroup from '../teaser/TeaserGroup.vue'

import type { LexiconParagraph } from '../../utils/paragraph-schema/paragraphs'
import type { Brand } from '@xcel-next/core/enums'

const props = withDefaults(defineProps<{
  lexicon: LexiconParagraph['lexicon']
  includeDepth?: number
  brand?: Brand
}>(), {
  includeDepth: 0
})

const alphabetList = 'abcdefghijklmnopqrstuvwxyz'.split('')

const composeTeasers = computed(() =>
  props.lexicon?.teasers
    ? props.lexicon.teasers.map((teaser) => ({
      ...teaser,
      imageId: props.lexicon.showTeaserImages ? teaser.imageId : false
    }))
    : undefined
)

const infoTeaser = computed(() => ({
  teaserGroupType: 'bx-teaser-container--lexicon',
  teasers: composeTeasers.value
}))

function addItemStyleClass (char: string) {
  return { 'bx-lexicon__active': char === props.lexicon.activeChar }
}
</script>

<template>
  <div v-if="lexicon?.alphabet"
       class="bx-content bx-lexicon bx-typo--lexicon">
    <h2 v-if="lexicon.headline">
      {{ lexicon.headline }}
    </h2>
    <ul id="lexicon-navi"
        class="bx-lexicon__navi">
      <li v-for="letter in alphabetList"
          :key="letter"
          :class="addItemStyleClass(letter)">
        <a v-if="lexicon.alphabet[letter] && letter !== lexicon.activeChar"
           :href="`${lexicon.lexiconUrl}?letter=${letter}`">
          {{ letter.toUpperCase() }}
        </a>
        <span v-else>{{ letter.toUpperCase() }}</span>
      </li>
    </ul>
    <TeaserGroup v-if="composeTeasers"
                 v-bind="infoTeaser"
                 :include-depth="includeDepth"
                 :brand="brand" />
    <div class="bx-lexicon__toplink">
      <a href="#lexicon-navi">
        <Icon name="arrow_toggle" />
        zur A-Z Übersicht
      </a>
    </div>
  </div>
</template>

